import React, {Component} from 'react';
import {Button, Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Col, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import Moment from "react-moment";
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { TbFileInvoice } from "react-icons/tb";
import AddAffiliateBoostModal from './modals/AddAffiliateBoostModal';

function getAffiliateList() {

    return fetch('https://back-api.therunningcollective.fr/affiliate-boosts', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class AffiliateBoostList extends Component {
    state = {
        errors: null,
        csvUsers: null,
    }

    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    async componentDidMount() {
        await getAffiliateList().then(data => {
            const uniqueNames = data
            this.setState({users: uniqueNames})
        }).catch(err =>
            this.setState({errors: "error while getting users"})
        );
    };

    closeModal() {
        this.setState({isOpen: false, isOpenModify: false})
    } 


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={9} className="products-buttons">
                        {(this.state.users && this.state.errors == null) ? <span>{this.state.users.length} boost(s)</span> : null }
                    </Col>
                    <Col sm={3} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"
                                onClick={(e) => this.setState({isOpen: true})}>Ajouter un boost</Button>
                    </Col>
                </Row>

                { (!this.state.users && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Nom</th>
                            <th>Prénom</th>
                            <th>Email</th>
                            <th>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.state.users &&  this.state.users.map(user => (
                            <tr>
                                <td>
                                    <Moment locale="fr" format="DD-MM-YYYY à HH:mm">
                                        {user.creationDate}
                                    </Moment>
                                </td>
                                <td>{user.lastName}</td>
                                <td>{user.firstName}</td>
                                <td>{user.email}</td>
                                <td>{user.total}€</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
                {this.state.isOpen ?
                    <AddAffiliateBoostModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                    />
                    :
                    null
                }
                
            </div>
        );

    }
}

